import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "type", "label", "value", "onChange", "fullWidth", "disabled", "placeholder", "inputProps", "className", "size", "helperText", "error", "sx", "InputProps", "id", "onBlur"];
import { FormControl, styled } from '@mui/material';
import TextField from '@mui/material/TextField';
//Examples
{ /* <InputBox
 name="UserName"
 onChange={onUserNameChange}
 type="text" //button, text, checkbox, password
 size="small"
 label="UserName"
 value={userNameValue}
 fullWidth={true}
 disabled={false}
 /> */
}
var InputField = styled(TextField)(function (_ref) {
    var theme = _ref.theme;
    return {
        "& .MuiInputBase-root.Mui-disabled": {
            "& > fieldset": {
                border: '1px solid #DEE4EB',
                boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)'
            },
            backgroundColor: "#F4F7FA",
            borderRadius: '8px'
        },
        "& fieldset": {
            border: '1px solid #DEE4EB',
            borderRadius: '8px'
        }
    };
});
export var InputBox = function (props) {
    var name = props.name, type = props.type, label = props.label, value = props.value, onChange = props.onChange, fullWidth = props.fullWidth, disabled = props.disabled, placeholder = props.placeholder, inputProps = props.inputProps, className = props.className, size = props.size, helperText = props.helperText, error = props.error, sx = props.sx, InputProps = props.InputProps, id = props.id, onBlur = props.onBlur, others = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(FormControl, {
        fullWidth: fullWidth,
        style: {
            margin: 0
        }
    }, /*#__PURE__*/ React.createElement(InputField, _extends({
        id: id,
        error: error,
        variant: "outlined",
        label: label,
        placeholder: placeholder,
        autoComplete: "none",
        name: name,
        type: type || "text",
        value: value,
        fullWidth: fullWidth,
        onChange: onChange,
        onBlur: onBlur,
        disabled: disabled,
        InputProps: InputProps,
        className: className,
        size: size,
        helperText: helperText || null,
        sx: sx,
        inputProps: inputProps
    }, error && {
        error: true,
        helperText: helperText ? helperText : error
    }, {
        style: {
            margin: 0
        }
    }, others)));
};
